module.exports = __webpack_public_path__ + "static/media/c-check.7a6aeaab.svg";